import React, { useMemo, useState } from 'react';
import { DataGrid, Lightbox } from '@fashionnovateam/nova-ui-toolkit';
import { InspoTableColumns } from '../../types/TableColumns';
import { columns } from './columns';
import { mapInspoToRows } from './mapInspoToRows';

export function NewItemRequestsTable() {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [slides, setSlides] = useState<{ src: string }[]>([]);

  const onPhotoClick = (photos: string[]) => {
    setSlides(photos.map((photo) => ({ src: photo })));
    setIsLightboxOpen(true);
  };

  const rows = useMemo(() => mapInspoToRows({ onPhotoClick }), []);

  return (
    <div className="h-full max-h-full overflow-hidden">
      <Lightbox
        slides={slides}
        isOpen={isLightboxOpen}
        onClose={() => setIsLightboxOpen(false)}
      />
      <DataGrid
        hideFilterButton
        hideGroupButton
        rows={rows}
        rowHeight={96}
        initialState={{
          pinnedColumns: {
            left: [InspoTableColumns.PHOTO, InspoTableColumns.LAST_MESSAGE],
          },
        }}
        columns={columns}
        classes={{
          columnHeaderTitle:
            'text-[11px] ' +
            '!whitespace-normal ' +
            '!break-words ' +
            '!overflow-visible ' +
            '[text-overflow:clip!important]',
          cell: 'flex items-center !break-all !overflow-visible !whitespace-normal [&>p]:text-[11px] [&>p]:font-[500] [&>p]:leading-[13px] [&>p]:text-gray-700',
          root: 'pb-4 ![img]:mt-4 rounded-none border-0',
        }}
      />
    </div>
  );
}
